"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_7oymi0ho8() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DocumentCheck.tsx";
  var hash = "e0f5a79053752b01b16a2318316f708aa97a8246";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/DocumentCheck.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 54
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e0f5a79053752b01b16a2318316f708aa97a8246"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_7oymi0ho8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_7oymi0ho8();
var Icon = (cov_7oymi0ho8().s[0]++, {
  name: 'document-check',
  svg: "<path d=\"M16.3839 11.8839C16.872 11.3957 16.872 10.6043 16.3839 10.1161C15.8957 9.62796 15.1043 9.62796 14.6161 10.1161L11 13.7322L9.38388 12.1161C8.89573 11.628 8.10427 11.628 7.61612 12.1161C7.12796 12.6043 7.12796 13.3957 7.61612 13.8839L11 17.2678L16.3839 11.8839Z\" fill=\"currentColor\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.5 2L2 8V19C2 20.6569 3.34315 22 5 22L19 22C20.6569 22 22 20.6569 22 19L22 5C22 3.34314 20.6569 2 19 2H7.5ZM19 19.5L5 19.5C4.72386 19.5 4.5 19.2761 4.5 19L4.5 10.25L8.5 10.25C9.74264 10.25 10.75 9.24264 10.75 8L10.75 4.5L19 4.5C19.2761 4.5 19.5 4.72386 19.5 5L19.5 19C19.5 19.2761 19.2761 19.5 19 19.5ZM8.25 7.75L5.62059 7.75L8.25 4.88155L8.25 7.75Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;